import { Injectable } from '@angular/core';
import { Subdivision } from './../subdivisions/subdivision';
import { City } from './../cities/city';
import { Observable, throwError, of, Subject, BehaviorSubject } from 'rxjs';
import { retry, catchError, map, finalize, tap } from 'rxjs/operators';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { MessagerComponent } from '../messager/messager/messager.component';
import { MatRipple } from '@angular/material/core';


@Injectable({
  providedIn: 'root'
})

export class TagService {


  private baseURL = environment.baseUrl;

  // MF / SF / GPS classification (tags.tagtypes), separate from the freeform tags.type.
  readonly TAG_TYPES = ['MF', 'SF', 'GPS'];

  constructor(private http: HttpClient,
    private messager: MessagerComponent) { }

  // Tags matching any selected type. Empty selection = show all; untyped tags
  // only show when no filter is active.
  filterByTypes(tags: any[], selected: string[]): any[] {
    if (!selected || selected.length === 0) { return tags || []; }
    return (tags || []).filter(t =>
      Array.isArray(t && t.tagtypes) && t.tagtypes.some(tt => selected.indexOf(tt) >= 0));
  }

  // Add/remove a type in the filter array, in place.
  toggleType(selected: string[], type: string): string[] {
    const i = selected.indexOf(type);
    if (i >= 0) { selected.splice(i, 1); } else { selected.push(type); }
    return selected;
  }

  basicRipple(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'lightgreen'
    });
    ripRef.fadeOut();
  }

  longRipple(theRipple: MatRipple) {
    const ripRef = theRipple.launch({
      persistent: true,
      centered: true,
      color: 'lightgreen',
      animation: {
        enterDuration : 1000,
        exitDuration : 2000
      }
    });
    ripRef.fadeOut();
  }

  getTag(tag_id):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getTag/' + tag_id, { observe: 'body' });
  }
  updateTagUseCount(idArray: any[]) {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/updateTagCount', idArray, { observe: 'body' });
  }

  getTags():Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getTags/', { observe: 'body' });
  }

  getSubdivisionTags(subdivision_id):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getSubdivisionTags/' + subdivision_id, { observe: 'body' });
  }

  getCustomerjobsTags(cj_id):Observable<any> {
    return this.http.get(this.baseURL + '/rhAPI/jobEntry/getCustomerjobsTags/' + cj_id, { observe: 'body' });
  }

  getTagNames(tags_array):Observable<any> {
    return this.http.post(this.baseURL + '/rhAPI/jobEntry/getJobTagNames', tags_array);
  }

  processTags(inputTags: any[]){

    //loop through all tags, grab the id and push to id array;
    let idArray = [];
    inputTags.forEach(element => idArray.push(element.id));

    //call API function to update tag use count:

    this.updateTagUseCount(idArray).subscribe(
      res => {
        console.log(res);
      });

  }




}
